module.exports = "/packs/media/images/bloombergscreen-382768ec4c65ffdb760497adfe901a98.jpeg";